$ = jQuery.noConflict();

$(() => {

  // function calcDistance(el1, el2, elresult){
  //   var a = $(el1).val() ? $(el1).val() : 0;
  //   var b = $(el2).val() ? $(el2).val() : 0;

  //   if(a && b)
  //     $(elresult).val(a-b);
  //   else
  //     $(elresult).val('');
  // }

  // $('#formcotacao').on('keyup change', '.target-distance-number-a, .target-distance-number-b', function() {
  //   calcDistance('.target-distance-number-a', '.target-distance-number-b', '.target-distance-result');
  // });

  function popup(popup_id){


    var popup = document.getElementById(popup_id);

    popup.classList.toggle("show");

  }

  $('#formconvidarcompradores').on('click', '.target-click-open-popup', function() {
    popup('myPopup');
  });


});
